import { ViewChild, ElementRef, Component, OnInit } from '@angular/core';
import { HomeService } from '../../services/home.service';
import { UtilService } from '../../services/util.service';
import { Router, RouterModule, Routes } from '@angular/router';
import {Observable} from 'rxjs/Rx';
import { error } from 'selenium-webdriver';

declare var jQuery:any;
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  deviceInfo = null;
  quotesObj:any={background:'',quote:''};
  postsObj:any=[];
  userObj:any=[];
  currentPathObj:any={image:'', status:{exercises_completed_percentage:0}};
  activeExerciseObj:any={description:''};
  lockedExercisesObj:any=[];
  completedExercisesObj:any=[];
  alignFix:boolean = false;
  @ViewChild('svgPath') svgPath:ElementRef;
  constructor(
    private homeService: HomeService,
    private router:Router,
    private utilService: UtilService
  ) { 
    this.getDeviceOs();
  }

  ngOnInit() {
    this.userCurrentPath();  
    this.quotes();  
    this.posts();  
    this.userDetails(); 
  }

  getDeviceOs() {
    this.deviceInfo = this.utilService.getDeviceInfo();
  }

  quotes() {
    this.homeService.getQuotes().subscribe(res=> {
      this.quotesObj = res;
    }); 
  }

  posts() {
    this.homeService.getPosts().subscribe(res=> {
      this.postsObj = res['results'];
      let convertedDate = null;
      for(let index of this.postsObj){
        convertedDate = this.convertDateToDays(index['created_at']);
        index['convertedDate'] = convertedDate;
      }
    }); 
  }

  userCurrentPath() {
    this.homeService.currentPath().subscribe(res=>{
      let active = false;
      this.currentPathObj = res;
      //Calculate the offset for the svg.
      if(res.status != undefined) {
        let completedPer = res.status['exercises_completed_percentage'];
        if(this.deviceInfo.os == 'mac') {
          this.alignFix = true;
          if(completedPer == 0) {
            completedPer = 0;
          }else if(completedPer == 100) {
            completedPer = 1;
          }else if(completedPer != 0) {
            completedPer = 100 - completedPer;
          }
        }
        let offset = (completedPer * 6.3) - 629;
        let svgViewPath = '<svg viewBox="-10 -10 220 220" #svgPath><path d="M200,100 C200,44 155.228475,0 100,0 C44.771525,0 0,44.771525 0,100 C0,155.228475 44.771525,200 100,200 C155.228475,200 200,155.228475 200,100 Z" stroke-dashoffset='+offset+' stroke-linecap="round" data-circle-type="percentage"></path></svg>'
        //Append svg path to the view.
        jQuery('.svg-view').append(svgViewPath);
        if(this.deviceInfo.os == 'mac') {
          jQuery('svg').css('transform','rotate(0deg)');
        }
        // this.svgPath.nativeElement.innerHTML = svgViewPath;
        
        //For completed exercises.
        for(let index of res['exercises']) {
          if(index.status.status == 'active'){
            active = true;
            this.activeExerciseObj = index;
          }else if(index.status.status == 'completed') {
            var formatedDate = this.formatDate(index.status.updated_at);
            //Add formated date to the obj as we need to show this date in the view.
            index['formatedDate'] = formatedDate;
            this.completedExercisesObj.push(index);
            //Add last completed exercise to active exercise if user completed all exercises.
            if(!active) {
              this.activeExerciseObj = index;
            }

          } else if(index.status.status == 'locked') {
            this.lockedExercisesObj.push(index);
          }
        }
      }
    });
  }

  userDetails() {
    this.utilService.userDetails().subscribe(res=>{
      this.userObj = res;
    });
  }

  formatDate(date) {
    var dt = new Date(date);
    var monthNames = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
    var convertedDate = null;
    convertedDate = dt.getDate() + " " + monthNames[dt.getMonth()] + " " + dt.getFullYear();
    return convertedDate;
  }

  convertDateToDays(date) {
    var oneDay = 24*60*60*1000; // hours*minutes*seconds*milliseconds
    var firstDate = new Date(date);
    var secondDate = new Date();
    var diffDays = Math.round(Math.abs((firstDate.getTime() - secondDate.getTime())/(oneDay)));
    var days = null;
    if(diffDays >= 365) {
      days = diffDays/365;
      days = parseInt(days.toString());
      days = (days == 1) ? 'a year ago': days+' years ago';
    }else if(diffDays != 0) {
      days = diffDays;
      days = (days == 1) ? 'a day ago': days+' days ago';
    } else {
      days = new Date(firstDate).getHours();
      if(days < 1) {
        days = new Date(firstDate).getMinutes();
        days = (days == 1) ? 'a minute ago': days+' minutes ago';
      } else {
        days = (days == 1) ? 'a hour ago': days+' hours ago';
      }
    }
    return days;
  }
}



// WEBPACK FOOTER //
// /Volumes/Projects/WellBrain_Azure_Web/src/app/components/home/home.component.ts